// Raw multiplexed-0080 recorder. Captures EVERY CE060080 packet the force-curve
// listener emits (`crewz-mux-packet`: { t, id, hex }) for one erg session and
// downloads it as CSV for human review. Module-level so recording survives the
// Settings card unmounting when the user switches to the Monitor to row.

let rec = null;          // { rows:[{t,id,hex}], startedAt }
let handler = null;
let lastRows = null;     // kept for "download again"
let lastStartedAt = 0;

export function isRecordingRawMux() { return !!rec; }
export function getRawMuxCount() { return rec ? rec.rows.length : 0; }
export function getLastRawMux() { return lastRows ? { rows: lastRows, startedAt: lastStartedAt } : null; }

export function startRawMuxRecording() {
  if (rec) return rec;
  rec = { rows: [], startedAt: Date.now() };
  handler = (e) => {
    const { t, id, hex } = e.detail || {};
    rec.rows.push({ t, id, hex });
    window.dispatchEvent(new CustomEvent('crewz-mux-log-tick', { detail: { count: rec.rows.length, lastId: id } }));
  };
  window.addEventListener('crewz-mux-packet', handler);
  window.dispatchEvent(new CustomEvent('crewz-mux-log-state', { detail: { recording: true, count: 0 } }));
  return rec;
}

export function stopRawMuxRecording() {
  if (!rec) return null;
  window.removeEventListener('crewz-mux-packet', handler);
  const done = rec;
  rec = null; handler = null;
  lastRows = done.rows; lastStartedAt = done.startedAt;
  window.dispatchEvent(new CustomEvent('crewz-mux-log-state', { detail: { recording: false, count: done.rows.length } }));
  return done;
}

export function downloadRawMuxCsv(rows, startedAt) {
  if (!rows || !rows.length) return;
  const header = 'elapsed_ms,iso_time,data_id_hex,bytes_hex\n';
  const body = rows.map((r) => {
    const el = r.t - startedAt;
    const iso = new Date(r.t).toISOString();
    const idHex = '0x' + Number(r.id ?? 0).toString(16).padStart(2, '0');
    const spaced = (r.hex || '').replace(/(..)/g, '$1 ').trim();
    return `${el},${iso},${idHex},${spaced}`;
  }).join('\n');
  const blob = new Blob([header + body + '\n'], { type: 'text/csv' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `crewz-pm5-raw0080-${new Date(startedAt).toISOString().slice(0, 19).replace(/[:T]/g, '')}.csv`;
  document.body.appendChild(a); a.click(); a.remove();
}
